module.exports = __webpack_public_path__ + "static/media/hub-logo.13fe9ceb.svg";